module.exports = __webpack_public_path__ + "static/media/Nguyen-Phi-Le.080eb8a7.png";